<template>
  <div>
    <v-card class="mb-4 rounded elevation-2 border" color="white">
      <!-- Header / Title Section -->
      <v-card-title
        class="d-flex flex-wrap align-center justify-space-between py-3 px-4 bg-grey-lighten-4"
      >
        <div class="d-flex flex-column mb-1 mb-sm-0">
          <div
            class="text-h6 font-weight-bold"
            :style="{ color: getThemeColor }"
          >
            <template v-if="selectedService">
              {{ selectedService.client?.name || "Client" }}
            </template>
            <template v-else>
              {{ getUserCompany?.industry }} Quotes, Billing and Invoicing
              System
            </template>
          </div>

          <div
            v-if="selectedService"
            class="text-caption text-grey-darken-1 font-weight-medium"
          >
            Ref: {{ selectedService.card_number || "" }}
          </div>
        </div>

        <!-- Status & Phase Chips -->
        <!-- <div v-if="selectedService" class="d-flex align-center flex-wrap gap-2">
                      <div class="text-grey-darken-1 mx-1">VIN: {{ selectedService.vin || '' }}</div> -->
        <!-- <v-btn
                      dark
                        v-if="selectedService.status"
                        
                        :color="'primary'"
                        variant="flat"
                        class="font-weight-medium"
                        small
                      >
                         <v-icon start size="14">mdi-clock-outline</v-icon>
                        Phase: {{ selectedService.status }}
                      </v-btn> -->
        <!-- </div> -->
        <!-- Print Invoice Button -->
        <div
          class="d-flex align-center flex-wrap gap-2 mt-2 mt-sm-0"
          v-if="selectedService"
        >
          <v-chip
            color="primary"
            variant="tonal"
            size="small"
            class="font-weight-medium"
            prepend-icon="mdi-text-short"
          >
            <span class="text-truncate" style="max-width: 300px">
              <ProFormaGenerator
                :invoice="selectedService"
                :title="
                  selectedService.invoice_number ? 'Invoice' : 'Quotation'
                "
                :buttunWithText="true"
              ></ProFormaGenerator>
            </span>
          </v-chip>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Details Grid -->
      <v-card-text v-if="selectedService" class="py-3 px-4">
        <v-row dense>
          <v-col cols="12" sm="6" md="3">
            <div class="text-caption text-grey-darken-1">Make</div>
            <div class="text-body-2 font-weight-medium">
              <v-icon size="16" class="mr-1 text-grey">mdi-car</v-icon>
              {{ selectedService.make || "" }}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <div class="text-caption text-grey-darken-1">Model</div>
            <div class="text-body-2 font-weight-medium">
              <v-icon size="16" class="mr-1 text-grey"
                >mdi-shield-badge-outline</v-icon
              >
              {{ selectedService.model || "" }} |
              {{ selectedService.year || "" }}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <div class="text-caption text-grey-darken-1">License Plate</div>
            <div class="text-body-2 font-weight-medium text-truncate">
              <v-icon size="16" class="mr-1 text-grey"
                >mdi-map-marker-outline</v-icon
              >
              {{ selectedService.license_plate || "" }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ProFormaGenerator from "@/modules/CaseManager/ProFormaGenerator.vue";

export default {
  props: {
    selectedService: {
      default: null,
    },
  },
  components: {
    ProFormaGenerator,
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
  },
  data: () => ({
    matterLabel: "service",
  }),
};
</script>
